import { render, staticRenderFns } from "./trendlhc.vue?vue&type=template&id=7d8514f3"
import script from "./trendlhc.vue?vue&type=script&lang=js"
export * from "./trendlhc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports